import {executeCall} from './CallService';

export const archiveCounts = async() => {
    const action = "query.dml";
    const data = {
        query: "archiveCounts"
    };
    return await executeCall(action, data);
}

export const archiveProjects = async() => {
    const action = "query.dml";
    const data = {
        query: "archiveProjects"
    };
    return await executeCall(action, data);
}

export const archiveRestoreProject = async(projectId, clearForeman) => {
    const action = "query.dml";
    const data = {
        query: "archiveRestoreProject",
        params: {
            projectId: projectId,
            clearForeman: clearForeman ? 1 : 0
        }

    };
    return await executeCall(action, data);
}
